(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-whatsapp-journey"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768 && document.querySelector('.mobile-slider')) {
    $('.mobile-slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '40px',
      arrows: false,
      responsive: [{
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
        }
      }]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodveda-reels"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const reelsSection = document.querySelector('.goodveda-reels-content');
      const skeletonSection = document.querySelector('.goodveda-reels-skeleton');

      function hideSkeleton() {
        skeletonSection.style.display = 'none';
        reelsSection.style.display = 'block';
      }

      // Simulate content loading process (adjust timing as necessary)
      setTimeout(() => {
        hideSkeleton();
      }, 2000); // Set an appropriate delay until content is fully ready

      const isMobile = window.innerWidth <= 767;
      let swiper;

      if (!isMobile) {
        swiper = new Swiper('.goodveda-reels-swiper', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          loop: true,
          navigation: {
            nextEl: '.goodveda-reel-button-next',
            prevEl: '.goodveda-reel-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 5,
            },
          }
        });
      } else {
        const reelsContainer = document.querySelector('.swiper-wrapper');
        const reelItems = document.querySelectorAll('.swiper-slide');

        const itemsToClone = Array.from(reelItems).slice(0, 3);
        itemsToClone.forEach(item => {
          const clone = item.cloneNode(true);
          reelsContainer.appendChild(clone);
        });

        reelsContainer.addEventListener('scroll', () => {
          if (reelsContainer.scrollLeft + reelsContainer.clientWidth >= reelsContainer.scrollWidth - 1) {
            reelsContainer.scrollLeft = 1;
          } else if (reelsContainer.scrollLeft <= 0) {
            reelsContainer.scrollLeft = reelsContainer.scrollWidth - reelsContainer.clientWidth - 1;
          }
        });
      }

      const reelItems = document.querySelectorAll('.goodveda-reel-item');
      const popup = document.querySelector('.video-popup');
      const popupVideo = popup.querySelector('video');
      const loadingSpinnerWrapper = popup.querySelector('.loading-spinner-wrapper');
      const closePopup = popup.querySelector('.close-popup');
      const popupBuyNowBtn = popup.querySelector('.popup-buy-now-btn');
      const popupNavPrev = popup.querySelector('.popup-nav-prev');
      const popupNavNext = popup.querySelector('.popup-nav-next');
      const playPauseBtn = popup.querySelector('.play-pause-btn');
      const videoWrapper = popup.querySelector('.video-wrapper');

      let currentReelIndex = 0;

      function loadVideo(video) {
        if (!video.src) {
          const source = video.querySelector('source');
          video.src = source.dataset.src;
          video.load();
        }
      }

      function showLoadingSpinner() {
        loadingSpinnerWrapper.style.display = 'block';
      }

      function hideLoadingSpinner() {
        loadingSpinnerWrapper.style.display = 'none';
      }

     function playVideo(video) {
    video.play().then(() => {
      hideLoadingSpinner();
    }).catch(error => {
      console.log("Auto-play was prevented:", error);
      hideLoadingSpinner();
    });
    // Disable iOS default video behavior
    video.setAttribute('playsinline', 'true');
    video.setAttribute('webkit-playsinline', 'true');
  }


      function pauseVideo(video) {
        video.pause();
        updatePlayPauseButton();
      }

      function togglePlayPause() {
        if (popupVideo.paused) {
          playVideo(popupVideo);
        } else {
          pauseVideo(popupVideo);
        }
      }

      function updatePlayPauseButton() {
        if (popupVideo.paused) {
          playPauseBtn.classList.add('paused');
          playPauseBtn.setAttribute('aria-label', 'Play');
        } else {
          playPauseBtn.classList.remove('paused');
          playPauseBtn.setAttribute('aria-label', 'Pause');
        }
      }

      function openPopupVideo(index) {
        const reelItem = reelItems[index];
        const video = reelItem.querySelector('video');

        currentReelIndex = index;
        popupVideo.src = video.src;
        popup.style.display = 'flex';

        showLoadingSpinner();
        playVideo(popupVideo);
        popupBuyNowBtn.setAttribute('href', reelItem.dataset.productUrl);
      }

      function updatePopupVideo(index) {
        const reelItem = reelItems[index];
        const video = reelItem.querySelector('video');

        currentReelIndex = index;
        popupVideo.src = video.src;

        showLoadingSpinner();
        playVideo(popupVideo);
        popupBuyNowBtn.setAttribute('href', reelItem.dataset.productUrl);
      }

      function closePopupVideo() {
        popup.style.display = 'none';
        pauseVideo(popupVideo);
      }

      reelItems.forEach((item, index) => {
        const video = item.querySelector('video');
        const playButton = item.querySelector('.play-button');

        loadVideo(video);

        item.addEventListener('mouseenter', () => {
          video.play();
          playButton.style.opacity = '0';
        });

        item.addEventListener('mouseleave', () => {
          video.pause();
          playButton.style.opacity = '1';
          video.load();
        });

        item.addEventListener('click', (e) => {
          e.preventDefault();
          openPopupVideo(index);
        });
      });

      closePopup.addEventListener('click', closePopupVideo);

      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          closePopupVideo();
        }
      });

      popupNavNext.addEventListener('click', () => {
        currentReelIndex = (currentReelIndex + 1) % reelItems.length;
        updatePopupVideo(currentReelIndex);
      });

      popupNavPrev.addEventListener('click', () => {
        currentReelIndex = (currentReelIndex - 1 + reelItems.length) % reelItems.length;
        updatePopupVideo(currentReelIndex);
      });

      videoWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePlayPause();
      });

      playPauseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePlayPause();
      });

      popupVideo.addEventListener('play', updatePlayPauseButton);
      popupVideo.addEventListener('pause', updatePlayPauseButton);
      popupVideo.addEventListener('canplay', hideLoadingSpinner);
      popupVideo.addEventListener('webkitendfullscreen', () => {
    togglePlayPause();
    hideLoadingSpinner();
  });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const menuButton = document.querySelector('.goodveda_h_header__menu');
    const navMenu = document.querySelector('.goodveda_h_nav-menu');
    const overlay = document.querySelector('.goodveda_h_overlay');
    const closeButton = document.querySelector('.goodveda_h_close-btn');
    const body = document.body;
    const closerElements = document.querySelectorAll('.goodveda_h_closer');

    menuButton.addEventListener('click', function() {
        navMenu.classList.add('open');
        overlay.classList.add('open');
        body.classList.add('menu-open');
    });

    function closeMenu() {
        navMenu.classList.remove('open');
        overlay.classList.remove('open');
        body.classList.remove('menu-open');
    }

    closeButton.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    closerElements.forEach(function(element) {
        element.addEventListener('click', closeMenu);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-journey"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768 && document.querySelector('.mobile-slider')) {
    $('.mobile-slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '40px',
      arrows: false,
      responsive: [{
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
        }
      }]
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
